<template>
  <section class="auth-form">
    <div class="small-tf-logo">
      WatchTower Technologies
    </div>
    <h2><slot name="title" /></h2>
    <p><slot name="description" /></p>
    <a
      href="mailto:support@watchtowerbenefits.com"
      v-text="'support@watchtowerbenefits.com'"
    />
  </section>
</template>

<script>
  export default {
    name: 'AppLanding',
  };
</script>

<style lang="scss" scoped>
  @import 'src/assets/styles/mixins';

  a {
    font-size: 14px;
  }
</style>
